import img6Reasons from 'src/assets/images/landing/blog/6-reasons-to-start-a-school-newspaper.png';
import imgEmpowering from 'src/assets/images/landing/blog/empowering-students-in-underserved-communities-through-innovative-writing-technology.png';
import imgEsther from 'src/assets/images/landing/blog/esther-wojcicki.png';
import imgExtra from 'src/assets/images/landing/blog/extra-extra-award-winning-edtech-startup-pressto-utilizes-ai-to-revolutionize-writing-instruction.png';
import imgRevision from 'src/assets/images/landing/blog/four-ways-to-teach-revision-as-part-of-the-writing-process.jpeg';
import imgReadingWriting from 'src/assets/images/landing/blog/how-reading-affects-writing-insights-from-cognitive-psychology.jpeg';
import imgEncourage from 'src/assets/images/landing/blog/how-to-encourage-young-writers.jpeg';
import imgMediaLiteracy from 'src/assets/images/landing/blog/media-literacy.png';
import imgNYC from 'src/assets/images/landing/blog/nyc-students-reporting-from-brooklyn-borough-hall.jpeg';
import imgLaunch from 'src/assets/images/landing/blog/pressto-launch.png';
import imgWritingBuddy from 'src/assets/images/landing/blog/pressto-unveils-writing-buddy-a-revolutionary-ai-tool-to-transform-student-writing-skills.gif';
import imgScience from 'src/assets/images/landing/blog/science-of-reading.jpg';
import imgStarting from 'src/assets/images/landing/blog/starting-a-school-newspaper.png';
import imgState from 'src/assets/images/landing/blog/state-of-teaching-2024.jpg';
import imgSummer from 'src/assets/images/landing/blog/summer-writing.png';
import imgTech from 'src/assets/images/landing/blog/technology-education.png';
import imgCritical from 'src/assets/images/landing/blog/the-link-between-writing-and-critical-thinking-in-teens.jpeg';
import imgOutlining from 'src/assets/images/landing/blog/the-science-of-outlining-improving-organization-in-writing.png';
import imgAILiteracy from 'src/assets/images/landing/blog/unlocking-the-mystery-of-ai-literacy-a-guide-to-understanding-ai.png';
import imgDisabilities from 'src/assets/images/landing/blog/using-pressto-for-students-with-disabilities.png';
import imgWhyMedia from 'src/assets/images/landing/blog/why-is-media-literacy-important.jpeg';
import imgWritingInstruction from 'src/assets/images/landing/blog/writing-instruction.png';
import imgWhyNewspaper from 'src/assets/images/landing/blog/why-every-elementary-school-needs-a-student-newspaper.jpg';
import imgJournalismReading from 'src/assets/images/landing/blog/student-journalism-and-the-science-of-reading.jpg';
import imgWritingBlocks from 'src/assets/images/landing/blog/writing-blocks-and-the-journalism-process.jpg';
import imgOpinionWriting from 'src/assets/images/landing/blog/opinion-writing-through-journalism.jpg';
import imgCrossCurricular from 'src/assets/images/landing/blog/cross-curricular-journalism-beyond-ela.jpg';
import imgStudentVoice from 'src/assets/images/landing/blog/student-voice-and-sel-through-journalism.jpg';
import imgELLs from 'src/assets/images/landing/blog/journalism-for-ells-and-multilingual-learners.jpg';
import imgPrincipalGuide from 'src/assets/images/landing/blog/principal-guide-to-school-newspapers.jpg';
import imgAIPartner from 'src/assets/images/landing/blog/ai-as-writing-partner-not-writing-replacement.jpg';
import imgGradeLevels from 'src/assets/images/landing/blog/from-5ws-to-front-page-journalism-across-grade-levels.jpg';

const BLOG_THUMBNAILS: Record<string, string> = {
  '6-reasons-to-start-a-school-newspaper': img6Reasons,
  'empowering-students-in-underserved-communities-through-innovative-writing-technology': imgEmpowering,
  'esther-wojcicki': imgEsther,
  'extra-extra-award-winning-edtech-startup-pressto-utilizes-ai-to-revolutionize-writing-instruction': imgExtra,
  'four-ways-to-teach-revision-as-part-of-the-writing-process': imgRevision,
  'how-reading-affects-writing-insights-from-cognitive-psychology': imgReadingWriting,
  'how-to-encourage-young-writers': imgEncourage,
  'media-literacy': imgMediaLiteracy,
  'nyc-students-reporting-from-brooklyn-borough-hall': imgNYC,
  'pressto-launch': imgLaunch,
  'pressto-unveils-writing-buddy-a-revolutionary-ai-tool-to-transform-student-writing-skills': imgWritingBuddy,
  'science-of-reading': imgScience,
  'starting-a-school-newspaper': imgStarting,
  'state-of-teaching-2024': imgState,
  'summer-writing': imgSummer,
  'technology-education': imgTech,
  'the-link-between-writing-and-critical-thinking-in-teens': imgCritical,
  'the-science-of-outlining-improving-organization-in-writing': imgOutlining,
  'unlocking-the-mystery-of-ai-literacy-a-guide-to-understanding-ai': imgAILiteracy,
  'using-pressto-for-students-with-disabilities': imgDisabilities,
  'why-is-media-literacy-important': imgWhyMedia,
  'writing-instruction': imgWritingInstruction,
  'why-every-elementary-school-needs-a-student-newspaper': imgWhyNewspaper,
  'student-journalism-and-the-science-of-reading': imgJournalismReading,
  'writing-blocks-and-the-journalism-process': imgWritingBlocks,
  'opinion-writing-through-journalism': imgOpinionWriting,
  'cross-curricular-journalism-beyond-ela': imgCrossCurricular,
  'student-voice-and-sel-through-journalism': imgStudentVoice,
  'journalism-for-ells-and-multilingual-learners': imgELLs,
  'principal-guide-to-school-newspapers': imgPrincipalGuide,
  'ai-as-writing-partner-not-writing-replacement': imgAIPartner,
  'from-5ws-to-front-page-journalism-across-grade-levels': imgGradeLevels,
};

export default BLOG_THUMBNAILS;
